1<template>
	<div class="filled-content">
		<v-toolbar app flat dark color="primary">
			<v-btn icon @click="goBack()">
				<v-icon>arrow_back</v-icon>
			</v-btn>
			<v-toolbar-title>E-finder toevoegen</v-toolbar-title>
			<v-btn icon></v-btn>
		</v-toolbar>

		<v-content class="uf-form">
			<v-list two-line class="ma-0 pa-0">
				<v-list-tile two-line avatar class="e-connectz_list-tile">
					<v-list-tile-avatar>
						<strong>2</strong>
					</v-list-tile-avatar>
					<v-list-tile-content>
						<v-list-tile-title class="font-weight-medium">Stap 2 - Abonneren</v-list-tile-title>
						<v-list-tile-sub-title>Betalen</v-list-tile-sub-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>
			<v-container class="item-group" v-if="loaded">

				<v-alert
					:value="paymentFailed"
					type="error"
					outline
					class="mb-4"
				>
					Betaling niet gelukt.
				</v-alert>

				<form @submit.prevent="submit">
					<validation-observer ref="validationObserver">
						<validation-provider name="Straat" rules="required" v-slot="{ errors }" slim>
							<v-text-field
								v-model="street"
								:error-messages="errors[0]"
								label="Straat *"
								required box hide-details
								class="mb-2"
							></v-text-field>
						</validation-provider>
						<validation-provider name="Huisnummer" rules="required" v-slot="{ errors }" slim>
							<v-text-field
								v-model="house_number"
								:error-messages="errors[0]"
								label="Huisnummer *"
								required box hide-details
								class="mb-2"
							></v-text-field>
						</validation-provider>
						<validation-provider name="Postcode" rules="required" v-slot="{ errors }" slim>
							<v-text-field
								v-model="postcode"
								:error-messages="errors[0]"
								label="Postcode *"
								required box hide-details
								class="mb-2"
							></v-text-field>
						</validation-provider>
						<validation-provider name="Plaats" rules="required" v-slot="{ errors }" slim>
							<v-text-field
								v-model="city"
								:error-messages="errors[0]"
								label="Plaats *"
								required box hide-details
								class="mb-2"
							></v-text-field>
						</validation-provider>
						<validation-provider name="Land" rules="required" v-slot="{ errors }" slim>
							<v-select
								v-model="country"
								:items="countries"
								:error-messages="errors[0]"
								label="Land *"
								required box hide-details
								class="mb-2"
							>
							</v-select>
						</validation-provider>
						<validation-provider name="Telefoonnummer" rules="required|phone" v-slot="{ errors }" slim>
							<v-text-field
								v-model="phone"
								:error-messages="errors[0]"
								mask="##-########"
								:rules="[(v) => v.length === 10 || 'Telefoonnummer moet bestaan uit 10 cijfers.']"
								label="Telefoon (mobiel) *"
								required box
								class="mb-4"
							></v-text-field>
						</validation-provider>
						<validation-provider name="Verkooppunt" rules="required" v-slot="{ errors }" slim>
							<v-text-field
								v-model="purchaseStore"
								:error-messages="errors[0]"
								label="Verkooppunt *"
								placeholder="Winkel of bedrijf waar je je E-finder heb gekocht"
								required box hide-details
								class="mb-2"
							></v-text-field>
						</validation-provider>
						<validation-provider name="Verkooppuntlocatie" rules="required" v-slot="{ errors }" slim>
							<v-text-field
								v-model="purchaseLocation"
								:error-messages="errors[0]"
								label="Verkooppuntlocatie *"
								placeholder="Stad waar deze winkel/bedrijf zich bevindt"
								required box
								class="mb-5"
							></v-text-field>
						</validation-provider>
					</validation-observer>

					<input type="hidden" :value="first_name">
					<input type="hidden" :value="last_name">
					<input type="hidden" :value="last_name_prefix">
					<input type="hidden" :value="email">

					<v-list three-line class="mb-4 py-0" v-if="selectedProduct">
						<v-list-tile avatar class="mb-2 product-tile">
							<v-list-tile-content>
								<v-list-tile-title class="font-weight-medium">
									{{ selectedProduct.name }}
								</v-list-tile-title>
								<v-list-tile-sub-title v-html="selectedProduct.description"></v-list-tile-sub-title>
							</v-list-tile-content>
							<v-list-tile-action>
								<v-flex class="text-xs-right">
									<strong>{{ (selectedProduct.price / 12) * .01 | currency }}</strong><br/>
									<small>per maand</small>
								</v-flex>
							</v-list-tile-action>
						</v-list-tile>
					</v-list>

					<div align="center" class="mb-5" v-if="selectedProduct">
						<h2>Totaal bedrag: {{ selectedProduct.price * 0.01 | currency }}</h2>
						<p class="mb-2 grey--text">Abonnementen worden per jaar vooraf betaald</p>
					</div>

					<v-btn type="submit"
						   :loading="processingSubmission"
						   block dark depressed large
						   color="primary">Betalen
					</v-btn>
				</form>
			</v-container>
		</v-content>
	</div>
</template>

<script>
  import SubscriptionService from '../../../services/SubscriptionService';
  import UserService from '../../../services/UserService';
  import { ValidationObserver, ValidationProvider } from 'vee-validate';
  import { createHelpers } from 'vuex-map-fields';
  import DeviceService from "../../../services/DeviceService";

  const { mapFields } = createHelpers({
    getterType: 'getUserField',
    mutationType: 'updateUserField',
  });

  export default {
    components: { ValidationProvider, ValidationObserver },
    computed: {
      products() {
        return this.$store.state.products.products;
      },
      selectedProduct() {
        return this.$store.state.products.products
          .find(product => product.id == this.selectedProductId);
      },
      ...mapFields([
        'first_name',
        'last_name',
        'last_name_prefix',
        'email',
        'phone',
        'street',
        'house_number',
        'postcode',
        'city',
        'country',
      ]),
    },
    data() {
      return {
        processingSubmission: false,
        loaded: false,
        paymentFailed: false,
        code: this.$route.params.slug,
        selectedProductId: this.$route.params.productId,
        errorMessage: '',
        loading: false,
	    	purchaseStore: '',
	    	purchaseLocation: '',
				countries: [
					"Nederland",
					"Luxemburg",
					"België",
					"Duitsland",
					"Verenigd Koninkrijk",
				]
      };
    },
    watch: {
      code(value) {
        this.$nextTick(() => {
          this.code = value.replace(/[^0-9A-Fa-f]+/gi, '')
            .toUpperCase();
        });
      },
      phone(value) {
        this.$nextTick(() => {
          this.phone = value.replace(/[^0-9]+/gi, '')
            .toUpperCase();
        });
      }
    },
    methods: {
      goBack(fallback) {
        this.$router.push({ name: 'devices.subscription', params: { slug: this.code } });
      },
      async submit() {
        const valid = await this.$refs.validationObserver.validate();
        if (!valid) return window.scrollTo(0, 0);

        this.processingSubmission = true;

        await UserService.update({
          first_name: this.first_name,
          last_name: this.last_name,
          last_name_prefix: this.last_name_prefix,
          email: this.email,
          street: this.street,
          house_number: this.house_number,
          postcode: this.postcode,
          city: this.city,
          country: this.country,
          phone: this.phone
        });

        const response = await SubscriptionService.create(this.code, this.selectedProductId, this.purchaseStore, this.purchaseLocation);
        window.location = response.url;
      },
      urlParams() {
        return new URLSearchParams(window.location.search);
      },
      loadProducts() {
        this.$store.dispatch('products/loadProducts')
          .then(() => {
            this.loaded = true;
          });
      }
    },
    created() {
      this.loadProducts();
      this.paymentFailed = (this.urlParams().get('failed') == 1);
    }
  };
</script>

<style lang="stylus">
	.uf-form
		position: relative
		background-color: #f2f2f2

	.item-group
		background-color: #fff
		border-top: solid 1px #ddd
		border-bottom: solid 1px #ddd

	.product-tile
		background-color: #fff
		border: solid 1px #dedede
		border-radius: .5rem

		.v-list__tile__avatar
			margin-top: 0

</style>
